import { usePurchaseItemStore } from "@/store/purchase-items.store.ts"
import { storeToRefs } from "pinia"
import { createRule } from "@regle/core"
import type { PurchaseItem } from "@/models/purchase-item.model.ts"

export const uniquePurchaseItemValidator = createRule({
  validator: (_value: unknown, purchaseItem: PurchaseItem) => {
    const purchaseItemStore = usePurchaseItemStore()
    const { purchaseItems } = storeToRefs(purchaseItemStore)

    if (!purchaseItem.name || !purchaseItem.unit || !purchaseItem.supplier) {
      return true
    }

    return !purchaseItems.value.some(
      (item) =>
        item.name.toLowerCase() === purchaseItem.name.toLowerCase() &&
        item.unit === purchaseItem.unit &&
        item.supplier.id === purchaseItem.supplier.id &&
        item.id !== purchaseItem.id
    )
  },
  message: "Er bestaat al een inkoopartikel met deze naam, eenheid en leverancier"
})
